import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, FreeMode } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/free-mode';
import MovieCard from '../MovieCard/MovieCard';
import './MovieCarousel.css';

const MovieCarousel = ({ title, movies, viewAllLink }) => {
  const swiperRef = useRef(null);

  return (
    <motion.section 
      className="movie-carousel"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
    >
      <div className="movie-carousel__header">
        <h3 className="movie-carousel__title">{title}</h3>
        {viewAllLink && (
          <a href={viewAllLink} className="movie-carousel__view-all">
            View All
          </a>
        )}
      </div>

      <div className="movie-carousel__container">
        <Swiper
          ref={swiperRef}
          modules={[Navigation, FreeMode]}
          spaceBetween={16}
          slidesPerView="auto"
          freeMode={true}
          navigation={{
            nextEl: '.movie-carousel__nav--next',
            prevEl: '.movie-carousel__nav--prev',
          }}
          breakpoints={{
            320: {
              slidesPerView: 2.2,
              spaceBetween: 12,
            },
            640: {
              slidesPerView: 3.2,
              spaceBetween: 16,
            },
            768: {
              slidesPerView: 4.2,
              spaceBetween: 16,
            },
            1024: {
              slidesPerView: 5.2,
              spaceBetween: 20,
            },
            1280: {
              slidesPerView: 6.2,
              spaceBetween: 20,
            },
          }}
          className="movie-carousel__swiper"
        >
          {movies.map((movie, index) => (
            <SwiperSlide key={movie.id || index} className="movie-carousel__slide">
              <MovieCard 
                movie={movie} 
                index={index}
                variant="poster"
              />
            </SwiperSlide>
          ))}
        </Swiper>

        <button className="movie-carousel__nav movie-carousel__nav--prev">
          <span className="material-icons">chevron_left</span>
        </button>
        <button className="movie-carousel__nav movie-carousel__nav--next">
          <span className="material-icons">chevron_right</span>
        </button>
      </div>
    </motion.section>
  );
};

export default MovieCarousel;